import dayjs from 'dayjs';
import Commons from '../../../../../Services/Common/Common';
const encryptWithDebug = (label, raw) => {
  if (process.env.NODE_ENV === 'development') {
    console.log(`[POL_BASIC_01][encrypt-before] ${label}:`, raw);
  }
  return Commons.EncryptAES(raw);
};

export const TRA_NEW_04_Schema = {
  fields: {
    eduForm: {
      tpmId: { initial: '', label: 'TPM 식별자' },
      eduTypeCd: { initial: '', label: '교육구분코드', required: 'Y' },
      eduNmCd: { initial: '', label: '교육명코드', required: 'Y' },
      eduContentsCd: { initial: '', label: '교육내용코드', required: 'Y' },
      eduDt: {
        initial: dayjs().format('YYYY-MM-DD'),
        label: '교육일',
        required: 'Y',
      },
      eduTm: { initial: '', label: '교육시간', required: 'Y' },
      eduPlace: { initial: '', label: '교육장소', required: 'Y' },
      eduManager: { initial: '', label: '교육담당자', required: 'Y' },

      eduTargetMCnt: { initial: '', label: '교육대상자수(남)', required: 'Y' },
      eduExecMCnt: { initial: '', label: '교육실시자수(남)', required: 'Y' },
      eduNoExecMCnt: {
        initial: '',
        label: '교육미실시자수(남)',
        required: 'Y',
      },

      eduTargetWCnt: { initial: '', label: '교육대상자수(여)', required: 'Y' },
      eduExecWCnt: { initial: '', label: '교육실시자수(여)', required: 'Y' },
      eduNoExecWCnt: {
        initial: '',
        label: '교육미실시자수(여)',
        required: 'Y',
      },

      eduNoExecReason1: { initial: '', label: '미실시사유1' },
      eduNoExecReason2: { initial: '', label: '미실시사유2' },
      eduNoExecReason3: { initial: '', label: '미실시사유3' },

      eduImageFileName1: { initial: '', label: '사진파일명1' },
      eduImageSaveName1: { initial: '', label: '사진저장명1' },
      eduImageFilePath1: { initial: '', label: '사진경로1' },

      eduImageFileName2: { initial: '', label: '사진파일명2' },
      eduImageSaveName2: { initial: '', label: '사진저장명2' },
      eduImageFilePath2: { initial: '', label: '사진경로2' },

      significant: { initial: '', label: '특이사항' },
    },
    memForm: {
      tpdId: { initial: '', label: '참석자식별자' },
      no: { initial: '', label: '순번' },
      jobType: { initial: '', label: '직종' },
      tpaUserId: { initial: '', label: '참석자ID' },
      userNm: { initial: '', label: '성명' },
      remark: { initial: '', label: '비고' },
    },
  },

  mapper: {
    search1: {
      UserId: (_, context) => context.userInfo?.userid || '',
      AuthCd: (_, context) =>
        Commons.EncryptAES(context.userInfo?.authCd ?? ''),
      CoCd: (_, context) =>
        Commons.EncryptAES(
          context.userInfo?.authCd === 'ADMIN'
            ? context.search?.coCd
            : context.userInfo?.coCd || ''
        ) || '',
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd ?? ''),
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText ?? ''),
    },
    search2: {
      DepCd: (_, context) =>
        encryptWithDebug('search2.DepCd', context.depCd || ''),
    },
    search3: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd),
    },
    search4: {
      DepCd: (_, context) => Commons.EncryptAES(context.depCd || ''),
    },

    save1: {
      DepCd: (row) => Commons.EncryptAES(row.depCd || ''),
      VideoLocation: (row) => Commons.EncryptAES(row.filePath || ''),
      VideoFileName: (row) => Commons.EncryptAES(row.fileName || ''),
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    save2: {
      DepCd: (row) => Commons.EncryptAES(row.depCd || ''),
      EduLocation: (row) => Commons.EncryptAES(row.filePath || ''),
      EduFileName: (row) => Commons.EncryptAES(row.fileName || ''),
      UserId: (_, context) => context.userInfo?.userid || '',
    },

    delete1: {
      EduFileId: (row) => Commons.EncryptAES(row.fileId || ''),
    },
    delete2: {
      EduVideoId: (row) => Commons.EncryptAES(row.fileId || ''),
    },
  },
};
